import main from "./page/main";
import apsaranta from "./page/apsaranta";
import change from "./page/change";
import timefloor from "./page/timefloor";
import liveserver from "./page/liveserver";
import event from "./page/event";

promokit.preload({
    complete: function() {
        $('.main__banner-link1').on('click', (e)=>{
            e.preventDefault();
            promokit.store('page').to(1);
        });
        $('.main__banner-link2').on('click', (e)=>{
            e.preventDefault();
            promokit.store('page').to(2);
        });
        $('.main__banner-link3').on('click', (e)=>{
            e.preventDefault();
            promokit.store('page').to(4);
        });
        $('.main__banner-link4').on('click', (e)=>{
            e.preventDefault();
            promokit.store('page').to(5);
        });
    }
});

var page = promokit.page({
    type:'fullpage-vertical',
    cnb: true, //true, false
    game: 'aion',

    headerButton: {
        el: '.header-button',
        cookie: {
            type: 'year', //'year', 'week', 'day'
            key: 'INDEX_WEB_VISIT_210203_update',
            value: false
        },
        home: true,
        update: true,
        sns: true,
        theme: 'black' //'black', 'white'
    },
    footer: {
        fixed: true,
        theme: 'white'
    },
    components:[
        main,
        apsaranta,
        timefloor,
        change,
        liveserver,
        event,
    ],
    menu: [
        {
            name: '업데이트 안내',
            group: [timefloor, change]
        }
    ]

});


$(document).on('click', '.apsaranta__btn', function(e) {
    e.preventDefault();
    window.open('https://aion.plaync.com/board/hotissue/view?articleId=1034167');
});

// event
$(document).on('click', '.event__slide .slider--1 a', function(e) {
    e.preventDefault();
    window.open('https://aion.plaync.com/board/notice/view?articleId=1051798');
});

$(document).on('click', '.event__slide .slider--2 a', function(e) {
    e.preventDefault();
    window.open('https://aion.plaync.com/board/notice/view?articleId=1046312');
});




// WEBPACK FOOTER //
// ./src/js/index.js